
import { supabase } from '@/integrations/supabase/client';

// Update user online status
export const updateUserOnlineStatus = async (isOnline: boolean) => {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    
    if (!user) return;
    
    const nowIso = new Date().toISOString();

    // Check if profile exists first to avoid foreign key violations
    // The profile is created by a trigger on auth.users, but there might be a race condition
    const { data: profile } = await supabase
      .from('profiles')
      .select('id')
      .eq('id', user.id)
      .single();
      
    if (!profile) {
      console.warn('Profile not found for user status update, skipping');
      return;
    }

    // Primary table
    const { error: statusError } = await supabase
      .from('user_status')
      .upsert({
        user_id: user.id,
        is_online: isOnline,
        last_seen: nowIso,
        updated_at: nowIso
      }, {
        onConflict: 'user_id'
      });
      
    if (statusError) {
      // Ignore 403 errors which are RLS related and might happen during initial signup/login
      if (statusError.code !== '42501') { 
        console.error('Error updating user_status:', statusError);
      }
    }

    // Fallback/legacy table support - fail silently
    await supabase
      .from('user_online_status')
      .upsert({
        user_id: user.id,
        is_online: isOnline,
        last_seen: nowIso
      }, {
        onConflict: 'user_id'
      }).catch(() => {});
      
  } catch (error) {
    // Fail silently for status updates to avoid spamming console
    // console.error('Error updating user status:', error);
  }
};

// Set up online status tracking
export const setupOnlineStatusTracking = () => {
  // Set user online when page loads
  updateUserOnlineStatus(true);
  
  // Set user offline when page unloads
  const handleBeforeUnload = () => {
    updateUserOnlineStatus(false);
  };
  
  window.addEventListener('beforeunload', handleBeforeUnload);
  
  // Clean up event listener
  return () => {
    window.removeEventListener('beforeunload', handleBeforeUnload);
    updateUserOnlineStatus(false);
  };
};
